import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray } from 'helpers/utils';
import { ColumnBib, ColumnNameH2H } from "components/common/TableColumns"
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

function HbbPlayerStats({ data, team }) {

  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters()

  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;
  let teamTotal = findArray(data?.results?.items, { startSortOrder: [team] })?.statsItems;

  let fieldAthletes = athletes?.filter(ath => ath.functionDescription !== 'Goalkeeper')
  let goalkeepers = athletes?.filter(ath => ath.functionDescription === 'Goalkeeper')

  let statsArray = ['SHOT', 'INF', 'SPN', 'SPE', 'SDG', 'OSG', '1P', 'PEN', 'SUS', 'DISQ', 'DDISQ', 'DDD', 'POINTS',
    'SHOT_GK', 'INF_GK', 'SPN_GK', 'SPE_GK', 'OSG_GK', 'OSG_GK', '1P_GK', 'PEN_GK'];

  let items = statsArray.map((item) => {
    let itemStat = item.split('/');
    let val;
    let extendedVal;
    let statsNotPos = Array.isArray(teamTotal) && teamTotal.filter(item => item.pos === undefined)
    val = findArray(teamTotal, { code: [itemStat[0]], pos: ['TOT'] })
    val = val ? val : findArray(statsNotPos, { code: [itemStat[0]] })
    if (itemStat.length > 1) {
      extendedVal = val.extendedStatsItems
    }

    return {
      code: itemStat[0], value: val?.value, attempt: val?.attempt, percent: val?.percent,
      extendedStatsItems: extendedVal
    }
  })

  let extraFieldBenchTeam = {
    athlete: { code: '100000' },
    bib: 100000,
    title: <strong><Label data='HeaderBenchTeam' /></strong>,
  }

  let extraFieldAthTotals = {
    athlete: { code: '200000' },
    bib: 200000,
    title: <strong><Label data='HeaderTotals' /></strong>,
    statsItems:
      items,
  }

  let extraGoalkeepersTotals = {
    athlete: { code: '200001' },
    bib: 200001,
    title: <strong><Label data='HeaderTotals' /></strong>,
    statsItems:
      items,
  }

  //Before to inser check if exist yet

  fieldAthletes = fieldAthletes?.filter(item => item.code !== 100000)
  fieldAthletes = fieldAthletes?.filter(item => item.code !== 200000)
  goalkeepers = goalkeepers?.filter(item => item.code !== 200001)

  if (!fieldAthletes) fieldAthletes = []
  if (!goalkeepers) goalkeepers = []

  fieldAthletes.push(extraFieldBenchTeam)
  fieldAthletes.push(extraFieldAthTotals)
  goalkeepers.push(extraGoalkeepersTotals)

  let competitorNoc = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.organisation?.code;
  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;
  //Field Athletes collumns
  const tableColumnsField = useMemo(() =>
    [
      {
        id: 'HeaderPlayers',
        Header: <Label data="HeaderPlayers" />,
        headerClassName: "text-center",
        columns: [
          ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
          ColumnNameH2H({ showStarter: false, hideNoc: true }),
        ]
      },
      {
        id: 'HeaderShots',
        Header: <Label data="HeaderShots" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsG/S',
            Header: <Label data="HeaderG/S" />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsShot%',
            Header: <Label data="HeaderPercent" />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let percent = findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).percent;
              return (
                <><PlayerStatsType value={percent} /></>
              )
            }
          },
          {
            id: 'PlayerStatsINF',
            Header: <Label data="HeaderINF" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['INF'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['INF'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSPS',
            Header: <Label data="HeaderSPS" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPN'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPN'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSPE',
            Header: <Label data="HeaderSPE" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPE'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPE'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDIG',
            Header: <Label data="HeaderDIG" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SDG'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SDG'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsOSG',
            Header: <Label data="HeaderOSG" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['OSG'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['OSG'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsONP',
            Header: <Label data="HeaderONP" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['1P'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['1P'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsP6M',
            Header: <Label data="HeaderP6M" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['PEN'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['PEN'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },

        ]
      },
      {
        id: 'HeaderPenalties',
        Header: <Label data="HeaderPenalties" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsSU',
            Header: <Label data="HeaderSU" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 2,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SUS'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDISQ',
            Header: <Label data="HeaderDISQ" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 2,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['DISQ'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDDISQ',
            Header: <Label data="HeaderDDISQ" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 2,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['DDISQ'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDDD',
            Header: <Label data="HeaderDDD" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 2,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['DDD'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          },
        ]
      },
      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsPTS',
        headerClassName: "text-center align-middle",
        id: 'HeaderPoints',
        columns: [
          {
            id: 'PlayerStatsPTS',
            Header: <Label data="HeaderPTS" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-center',
            isVisible: false,
            remove: true,
            columnIndex: 3,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['POINTS'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          }
        ]
      },
    ], []
  )

  const tableColumnsFieldSM = useMemo(() =>
    [
      {
        id: 'HeaderPlayers',
        Header: <Label data="HeaderPlayers" />,
        headerClassName: "text-center",
        columns: [
          ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
          ColumnNameH2H({ showStarter: false, hideNoc: true }),
        ]
      },
      {
        id: 'HeaderShots',
        Header: <Label data="HeaderShots" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsG/S',
            Header: <Label data="HeaderG/S" />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsShot%',
            Header: <Label data="HeaderPercent" />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let percent = findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).percent;
              return (
                <><PlayerStatsType value={percent} /></>
              )
            }
          },
          {
            id: 'PlayerStatsINF',
            Header: <Label data="HeaderINF" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['INF'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['INF'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSPS',
            Header: <Label data="HeaderSPS" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPN'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPN'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSPE',
            Header: <Label data="HeaderSPE" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPE'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPE'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDIG',
            Header: <Label data="HeaderDIG" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SDG'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SDG'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsOSG',
            Header: <Label data="HeaderOSG" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['OSG'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['OSG'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsONP',
            Header: <Label data="HeaderONP" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['1P'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['1P'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsP6M',
            Header: <Label data="HeaderP6M" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['PEN'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['PEN'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },

        ]
      },
      {
        id: 'HeaderPenalties',
        Header: <Label data="HeaderPenalties" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsSU',
            Header: <Label data="HeaderSU" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 2,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SUS'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDISQ',
            Header: <Label data="HeaderDISQ" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 2,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['DISQ'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDDISQ',
            Header: <Label data="HeaderDDISQ" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 2,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['DDISQ'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDDD',
            Header: <Label data="HeaderDDD" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 2,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['DDD'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          },
        ]
      },
      {
        Header: "-",
        enableRowSpan: true,
        relatedId: 'PlayerStatsPTS',
        headerClassName: "text-center align-middle",
        id: 'HeaderPoints',
        columns: [
          {
            id: 'PlayerStatsPTS',
            Header: <Label data="HeaderPTS" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-center',
            isVisible: false,
            remove: true,
            columnIndex: 3,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['POINTS'] }).value;
              return (
                <><PlayerStatsType value={value} /></>
              )
            }
          }
        ]
      },
    ], []
  )

  //Goalskeepers collumns
  const tableColumnsGoal = useMemo(() =>
    [
      {
        id: 'HeaderGoalkeepers',
        Header: <Label data="LabelGoalkeepers" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
          ColumnNameH2H({ showStarter: false, hideNoc: true }),
        ]
      },
      {
        id: 'HeaderSaves',
        Header: <Label data="HeaderSaves" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsSaves',
            Header: <Label data="HeaderSAVES" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SHOT_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SHOT_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSaves%',
            Header: <Label data="HeaderPercent" />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let percent = findArray(props.cell.row.original.statsItems, { code: ['SHOT_GK'] }).percent;
              return (
                <><PlayerStatsType value={percent} /></>
              )
            }
          },
          {
            id: 'PlayerStatsINF',
            Header: <Label data="HeaderINF" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['INF_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['INF_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSPS',
            Header: <Label data="HeaderSPS" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPN_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPN_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSPE',
            Header: <Label data="HeaderSPE" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPE_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPE_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDIG',
            Header: <Label data="HeaderDIG" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SDG_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SDG_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsOSG',
            Header: <Label data="HeaderOSG" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['OSG_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['OSG_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsONP',
            Header: <Label data="HeaderONP" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['1P_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['1P_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsP6M',
            Header: <Label data="HeaderP6M" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['PEN_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['PEN_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
        ]
      }
    ], []
  )

  const tableColumnsGoalSM = useMemo(() =>
    [
      {
        id: 'HeaderGoalkeepers',
        Header: <Label data="LabelGoalkeepers" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          ColumnBib({ disableSort: true, label: 'HeaderNumber', expecialCase: true }),
          ColumnNameH2H({ showStarter: false, hideNoc: true }),
        ]
      },
      {
        id: 'HeaderSaves',
        Header: <Label data="HeaderSaves" sport={mirs_discipline} />,
        headerClassName: "text-center",
        columns: [
          {
            id: 'PlayerStatsSaves',
            Header: <Label data="HeaderSAVES" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SHOT_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SHOT_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSaves%',
            Header: <Label data="HeaderPercent" />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let percent = findArray(props.cell.row.original.statsItems, { code: ['SHOT_GK'] }).percent;
              return (
                <><PlayerStatsType value={percent} /></>
              )
            }
          },
          {
            id: 'PlayerStatsINF',
            Header: <Label data="HeaderINF" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['INF_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['INF_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSPS',
            Header: <Label data="HeaderSPS" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPN_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPN_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsSPE',
            Header: <Label data="HeaderSPE" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SPE_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SPE_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsDIG',
            Header: <Label data="HeaderDIG" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['SDG_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['SDG_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsOSG',
            Header: <Label data="HeaderOSG" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['OSG_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['OSG_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsONP',
            Header: <Label data="HeaderONP" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['1P_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['1P_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
          {
            id: 'PlayerStatsP6M',
            Header: <Label data="HeaderP6M" sport={mirs_discipline} />,
            headerClassName: "text-end",
            className: 'text-end w-5',
            isVisible: false,
            columnIndex: 1,
            Cell: (props) => {
              let value = findArray(props.cell.row.original.statsItems, { code: ['PEN_GK'] }).value;
              let attempt = findArray(props.cell.row.original.statsItems, { code: ['PEN_GK'] }).attempt;
              return (
                <><PlayerStatsType1 value={value} attempt={attempt} /></>
              )
            }
          },
        ]
      }
    ], []
  )

  let _captionField = <CaptionTeam competitorNoc={competitorNoc} participant={participant} />

  const { breakPoint } = useViewport();
  let columnsField = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsFieldSM : tableColumnsField
  let columnsGoal = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsGoalSM : tableColumnsGoal

  return (
    <>{ }

      <MirsTable
        id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        caption={_captionField}
        data={fieldAthletes}
        columns={columnsField}
        keyRow={"athlete-code"}
        initialSortBy={[{ id: 'Bib', desc: false }]}
        colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '5,5,4' : '14'}
        showNavExtendedData={true}
        colIndex={1}
      />
      <MirsTable
        id={`mirs-table-goalkeeper-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        data={goalkeepers}
        columns={columnsGoal}
        keyRow={"athlete-code"}
        initialSortBy={[{ id: 'Bib', desc: false }]}
        colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '5,4' : '9'}
        showNavExtendedData={true}
        colIndex={1}
      />
    </>
  );
}

export default HbbPlayerStats;

function CaptionTeam({ competitorNoc, participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div>
  )
}

function PlayerStatsType({ value }) {
  if (value !== undefined && value !== '0') {
    return (
      <>
        {value}
      </>
    )
  }
}

function PlayerStatsType1({ value, attempt }) {
  if (value !== undefined) {
    return (
      <>
        {value}/{attempt}
      </>
    )
  }
}